function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 2H17V3L15.5528 3.7236C15.214 3.89299 15 4.23926 15 4.61803V9C15 11.9217 12.4805 14.2665 9.50018 13.9755C6.90274 13.722 5 11.3868 5 8.777V4.61803C5 4.23926 4.786 3.893 4.44721 3.72361L3 3V2H9V3L7.55279 3.72361C7.214 3.893 7 4.23926 7 4.61803V9C7 10.8499 8.68269 12.3139 10.5979 11.9418C12.0222 11.6652 13 10.3325 13 8.8816V4.61803C13 4.23926 12.786 3.893 12.4472 3.72361L11 3V2ZM2 16H18V18H2V16Z",
  fill: "currentColor"
});

function SvgFontUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontUnderline);
export default __webpack_public_path__ + "static/media/font-underline.fe68d2bb.svg";
export { ForwardRef as ReactComponent };